/* eslint-disable prettier/prettier */
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import Table from "../../../../components/generic-table";
import { useCategories } from "../../../../hooks/categories";
import { language } from "../../../../language";

const INITIAL_STATE = {
  firstResult: 0,
  pageSize: 10,
  sortBy: "id",
  sortOrder: "asc",
  searchTerm: "",
  checkeds: null,
};

//componente usado no modeler aonde não pode ser usado redux por não estar conectado à store
const CategorySelectListPage = ({
  selectedcategories,
  onchangeCategorySelect,
}) => {
  const apiRef = useGridApiRef();

  const [pagination, setPagination] = useState(INITIAL_STATE);
  const { data: categoryList } = useCategories({
    params: pagination,
  });

  useEffect(() => {
    if (!categoryList?.length) return;
    const category = categoryList.find(
      (cat) => cat.name === Object.keys(selectedcategories)[0],
    );
    const selecteds = {
      type: "include",
      ids: new Set(category ? [category.id] : []),
    };
    apiRef.current?.setRowSelectionModel(selecteds);
  }, [selectedcategories, categoryList]);

  const handleChange = (data) => {
    if (!data.ids.size) return;
    const selectedCategory = categoryList.find(
      (category) => category.id === [...data.ids][0],
    );
    onchangeCategorySelect(selectedCategory);
  };

  const dataPagination = {
    callData: setPagination,
    totalElements: categoryList?.totalElements,
    model: {
      ...pagination,
      count: categoryList?.size,
      sortHeader: INITIAL_STATE.sortBy,
    },
    extraParameter: {
      listOrganizationMembers: true,
    },
  };

  const dataTable = {
    title: language.categories,
    headers: [{ title: language.name, field: "name" }],

    actions: [],
    data: categoryList && categoryList.length > 0 ? categoryList : [],
  };

  return (
    <div>
      <Table
        apiRef={apiRef}
        tableData={dataTable}
        pagination={dataPagination}
        onRowSelectionModelChange={handleChange}
        checkboxSelection
        disableMultipleRowSelection
      />
    </div>
  );
};

CategorySelectListPage.propTypes = {
  selectedcategories: PropTypes.object.isRequired,
  onchangeCategorySelect: PropTypes.func.isRequired,
};

export default CategorySelectListPage;
